export const debounce = (func, timeout = 250) => {
  let timer = null

  return (...args) => {
    timer && clearTimeout(timer)
    timer = setTimeout(() => func.apply(this, args), timeout)
  }
}
